export default "__VITE_ASSET__BOfd1d7G__"